module.exports = __webpack_public_path__ + "static/img/lunbo2.506301c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lunbo2.png
// module id = 4uOK
// module chunks = 1